export default "__VITE_ASSET__DhXfyVbh__"